import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { strings } from '/imports/strings';
import { randomString } from '/imports/utils';
import { useMethod, useUser } from '/imports/hooks';
import { Org, modelClass, orgName, canListOrgs } from '/imports/api/orgs';
import { Button } from '/imports/ui/Button';
import { NotPermittedPage } from '/imports/ui/NotPermittedPage';
import { Page } from '/imports/ui/Page';
import { PageHeading } from '/imports/ui/PageHeading';
import { PageBody } from '/imports/ui/PageBody';
import { DataCatalog } from '/imports/ui/DataCatalog';
import { createActiveFilter } from '/imports/ui/ActiveFilter';

export const OrgsPage = () => {
  const user = useUser();
  const [orgs, loading] = useMethod(modelClass.listMethod, {});
  const ActiveFilter = useMemo(() => createActiveFilter<Org>(), []);
  const [catalogKey, setCatalogKey] = useState(randomString());
  if (user && !canListOrgs(user)) return <NotPermittedPage />;
  return (
    <Page className={`page${loading ? ' initializing' : ''}`} breadcrumbs={[{ path: '/orgs', label: strings.Organizations() }]}>
      <PageHeading
        left={<h1>{strings.Organizations()}</h1>}
        right={
          <div>
            <Link to={'/orgs/new'}><Button>{strings.New()}</Button></Link>
          </div>
        }
      />
      <PageBody>
        <DataCatalog<Org>
          key={catalogKey}
          data={(orgs?.documents || []) as Org[]}
          columns={[
            { field: 'name', render: (org) => <Link to={`/orgs/${org._id}`}>{orgName(org)}</Link> },
            { field: 'phone' },
          ]}
          tools={
            <div className="filters">
              <span className="filters-label">{strings.Filters()}:</span>
              <ActiveFilter.Component onChange={() => setCatalogKey(randomString())} />
            </div>
          }
          filters={[ActiveFilter.filter()]}
          loading={loading}
        />
      </PageBody>
    </Page>
  );
};